import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { startWith } from 'rxjs/operators/startWith';
import { map } from 'rxjs/operators/map';
import { Question } from '../../models/question.class';
import { DataEnadisService } from '../../services/data-enadis/data-enadis.service';
import * as _ from 'lodash';
import { UtilsService } from '../../services/utils/utils.service';
import { MatAutocompleteTrigger } from '@angular/material';

/**
 * EnadisExploreComponentn
 * ENADIS Explore lets choose through 2 filters of Topic and subtopic, a variable of interest
 */
@Component({
  selector: 'app-enadis-explore',
  templateUrl: './enadis-explore.component.html',
  styleUrls: ['./enadis-explore.component.scss']
})
export class EnadisExploreComponent implements OnInit, AfterViewInit {
  /** MatAutoCompleteTrigger for question autocomplete */
  @ViewChild('matQuestion', { read: MatAutocompleteTrigger }) trigger: MatAutocompleteTrigger;
  /** Var who marks the number of aplication flow */
  step: number;
  /** Selected topics in string */
  selectedTopicName: string;
  /** Topic whichs filters variables */
  selectedTopic: { key: string, values: {}[] };
  /** SubTopic whichs filters variables  */
  selectedSubtopic: { key: string, values: Question[] };
  /** Contains all variables from ENADIS  */
  allVariables: Array<Question> = [];
  /** Contains the variables after topic and subtopic filters */
  variables: Array<Question> = [];
  /** Contains all ambitos used in Enadis */
  allAmbito: Array<any> = [];
  /** Contains names of ámbitos */
  ambitoNames: Array<any> = [];
  /** Contains all groups used in Enadis */
  allGroups: Array<any> = [];
  /** Contains names of groups */
  groupNames: Array<any> = [];
  /** Array with names of first column of groups */
  groupNamesOne: Array<any> = [];
  /** Array with names of second column of groups */
  groupNamesTwo: Array<any> = [];
  /** Array with names of third column of groups */
  groupNamesThree: Array<any> = [];
  /** Nombres de los temas de los ámbitos */
  ambGroupNames: Array<any> = [];
  /** Topic for every ambito  */
  ambTopic: Array<any> = [];
  /** Topic for every group */
  groupTopic: Array<any> = [];
  /** All Topics for group  */
  allGroupTopic: Array<Question> = [];
  /** Filtered variables for ambitos  */
  ambVariables: Array<any> = [];
  /** Filtered variables for groups */
  groupVariables: Array<any> = [];
  /** Object Structure for all topics  */
  topics: { key: string, values: {}[] }[] = [];
  /** Object Structure for all subtopics  */
  allSubTopics: { key: string, values: {}[] }[] = [];
  /** All gral subtopics   */
  subtopics: Array<Object> = [];
  /** Autcomplete control for variable */
  searchVariable: FormControl;
  /** Variables resulted as a filter from groups or ambitos */
  filteredVariables: Observable<any>;
  /** Value of selected variable by user  */
  selectedVariable: Question;
  /**
  * Used to show user know if selecting Topic or subtopic
  */
  showGroups = {
    state: true,
    mainText: ' POBLACIÓN O GRUPO',
    subText: ' TEMA',
  };
  /** Set an empty object to catch params from URL */
  queryParams = {};

  /**
   * Constructor for main class
   * @param dbService Service to connect, send request and get info from DB
   * @param utils Utilities service to filter, or process data
   */
  constructor(
    private dbService: DataEnadisService,
    private utils: UtilsService) { }

  /** Angulars Lyfeclicle method  */
  ngAfterViewInit() {
  }

  /** Angulars Lyfeclicle method  */
  ngOnInit() {
    this.step = 0;
    this.searchVariable = new FormControl();
    this.searchVariable.setValue(undefined);

    /** Load catalog of questions */
    this.dbService.getCodebook()
      .subscribe(questions => {
        this.allVariables = questions.map(obj => new Question(obj)); // Map data to Question objects
        this.variables = this.allVariables.sort(this.sortVariables);
        this.searchAmbito(this.variables);
        this.searchGroups(this.variables);

        this.filteredVariables = this.searchVariable.valueChanges
          .pipe(
            startWith(''),
            map(variable => variable ? this.filterVariables(variable) : this.variables.slice().sort(this.sortVariables))
          );
      });
  }

  /**
   * Order variables alphabetically
   * @param a First variable to be compared
   * @param b Second variable to be compared
   */
  sortVariables(a: Question, b: Question) {
    return a.shortName.localeCompare(b.shortName, undefined, { numeric: true });
  }

  /**
   * Search Ambitos on the variables, and return names of all ambitos in * ENADIS
   * @param questions Variables to get filters on
   */
  searchAmbito(questions) {
    const qAmbito = questions.filter(function (q) {
      if (q && q.Ambito && q.Ambito.includes(',')) {
        q.Ambito = q.Ambito.split(',');
      }
      return q.Ambito !== '';
    });

    this.allAmbito = qAmbito;
    this.ambVariables = qAmbito.map(obj => new Question(obj));

    const justAmbito = _.flatten(qAmbito.map(function (a) {
      return a.Ambito;
    }));

    this.ambitoNames = _.uniq(justAmbito);
  }

  /**
   * Search Groups on the variables, and return names of all groups in ENADIS
   * @param questions Variables to get filters on
   */
  searchGroups(questions) {
    const qgrupos = questions.filter(function (q) {
      if (q && q.grupos && q.grupos.includes(',')) {
        q.grupos = q.grupos.split(',');
      }
      return q.grupos !== '';
    });

    this.allGroups = qgrupos;
    this.groupVariables = qgrupos.map(obj => new Question(obj));

    const justgrupos = _.flatten(qgrupos.map(function (a) {
      return a.grupos;
    }));

    this.groupNames = _.uniq(justgrupos).filter(g => g);

    this.groupNamesOne = [
      {
        name: 'Población de 18 años y más (opiniones y experiencias de discriminación)',
        slug: 'Cuestionario de opiniones y experiencias'
      },
      {
        name: 'Características sociodemográficas de la población',
        slug: 'Características sociodemográficas'
      }
    ];

    this.groupNamesTwo = [
      {
        name: 'Personas indígenas',
        slug: 'Personas indígenas'
      },
      {
        name: 'Personas con discapacidad',
        slug: 'Personas con discapacidad'
      },
      {
        name: 'Personas de la diversidad religiosa',
        slug: 'Personas de la diversidad religiosa'
      },
      {
        name: 'Personas afrodescendientes',
        slug: 'Afrodescendientes'
      },
      {
        name: 'Personas de la diversidad sexual',
        slug: 'Personas no heterosexuales'
      }
    ];

    this.groupNamesThree = [
      {
        name: 'Mujeres',
        slug: 'Mujeres'
      },
      {
        name: 'Trabajadoras del hogar remuneradas',
        slug: 'Trabajadoras del hogar remuneradas'
      },
      {
        name: 'Niñas y niños (9 a 11 años)',
        slug: 'Niñas y niños'
      },
      {
        name: 'Adolescentes y jóvenes (12 a 29 años)',
        slug: 'Adolescentes y jóvenes'
      },
      {
        name: 'Personas mayores (60 años y más)',
        slug: 'Personas adultas mayores'
      }
    ];
  }

  /**
   * Reads which group has been selected and assign expFactor to that
   * group
   * @param grupo Value of group wanted to know the factor of
   */
  getGroupFactor(grupo) {
    switch (grupo) {
      case 'Personas indígenas':
        return 'FACTOR_IND';
      case 'Personas con discapacidad':
        return 'FACTOR_DIS';
      case 'Personas de la diversidad religiosa':
        return 'FACTOR_REL';
      case 'Personas adultas mayores':
        return 'FACTOR_ADU';
      case 'Niñas y niños':
        return 'FACTOR_NIN';
      case 'Adolescentes y jóvenes':
        return 'FACTOR_ADO';
      case 'Mujeres':
        return 'FACTOR_MUJ';
      case 'Personas no heterosexuales':
        return 'FACTOR_COE';
      case 'Trabajadoras del hogar remuneradas':
        return 'FACTOR_MUJ';
      case 'Afrodescendientes':
        return 'FACTOR_SDE';
      case 'Cuestionario de opiniones y experiencias':
        return 'FACTOR_COE';
      case 'Características sociodemográficas':
        return 'FACTOR_SDE';
      default:
        return null;
    }
  }

  /**
   * Read variables and sets ambito for them when selected
   * ambito
   * @param context Topic selected from Ambito
   */
  setAmbito(context) {
    this.selectedTopicName = context;
    this.selectedTopic = context;
    const allAmbTopic = this.allAmbito.filter(function (fa) {
      if (fa && fa.grupos && fa.grupos.includes(',')) {
        fa.grupos = fa.grupos.split(',');
      }
      return fa.grupos !== '' && fa.Ambito === context || (Array.isArray(fa.Ambito) && _.includes(fa.Ambito, context));
    });

    this.ambVariables = allAmbTopic.map(obj => new Question(obj)).sort(this.sortVariables);

    const justgrupos = _.flatten(allAmbTopic.map(function (a) {
      return a.grupos;
    }));

    this.ambGroupNames = _.uniq(this.ambVariables.map(g => g.topic)).filter(g => g);
    this.variables = this.ambVariables;
    this.ambTopic = this.variables;
    this.step = 0;
    this.queryParams = {
      ambito: context
    };
    this.nextStep();
  }

  /**
   * Read variables and sets Topic for them when selected
   * ambito
   * @param atopic Subtopic selected from ambito
   */
  setAmbTopic(atopic) {
    this.selectedSubtopic = atopic;
    const factor = this.getGroupFactor(atopic);
    this.variables = this.ambVariables.filter(function (fa) {
      let result = fa.topic === atopic || (Array.isArray(fa.grupos) &&
        _.includes(fa.grupos, atopic));
      if (factor) {
        result = result && factor === fa.collapseBy;
      }
      return result;
    }.bind(this));
    this.step = 1;
    this.queryParams['grupo'] = atopic;
    this.searchVariable.setValue(undefined);
    this.nextStep();
  }

  /**
   * Read variables and sets Topic Group for them when
   * selected group
   * @param context  Topic selected from Group
   */
  setGroup(context) {
    this.selectedTopicName = context.name;
    this.selectedTopic = context.slug;
    const factor = this.getGroupFactor(context.slug);
    this.allGroupTopic = this.allGroups.filter(function (fa) {
      let result = fa.grupos === context.slug || (Array.isArray(fa.grupos) &&
        _.includes(fa.grupos, context.slug));
      if (factor) {
        result = result && (factor === fa.collapseBy ||
          (_.includes(['FACTOR_SDE'], fa.collapseBy)) && this.selectedTopic !== 'Cuestionario de opiniones y experiencias');
      }
      return result;
    }.bind(this));
    this.groupVariables = this.allGroupTopic;
    this.variables = this.allGroupTopic;
    this.groupTopic = _.uniqBy(this.allGroupTopic, 'subtopic');
    this.step = 0;
    this.queryParams = {
      grupo: context.slug
    };
    this.nextStep();
  }

  /**
   * Read variables and sets subtopic group for them when
   * selected group
   * @param atopic Subtopic selected from group
   */
  setGroupTopic(atopic) {
    this.selectedSubtopic = atopic.subtopic;
    this.variables = this.groupVariables.filter(function (fv) {
      return fv.subtopic === atopic.subtopic;
    });
    this.searchVariable.setValue(undefined);
    this.step = 1;
    this.queryParams['tema'] = atopic;
    this.nextStep();
  }

  /**
   * Checks if a string or Object
   * Filter and order alphabetically
   * @param name name of variable
   */
  filterVariables(name: string) {
    if (typeof name === 'string') {
      return this.variables.filter(variable =>
        this.utils.stripSpecialCharacters(variable.shortName).indexOf(
          this.utils.stripSpecialCharacters(name)) > -1).sort(this.sortVariables);
    } else if (name['question']) {
      // variable is a selected object
      if (this.queryParams['grupo']) {
        this.selectedVariable = name;
      } else {
        this.selectedVariable = undefined;
      }
      return this.variables.filter(variable =>
        this.utils.stripSpecialCharacters(variable.shortName).indexOf(
          this.utils.stripSpecialCharacters(name['shortName'])) > -1).sort(this.sortVariables);
    }
  }

  /**
   * Set which step the app is in
   * @param index Actual step of app's flow
   */
  setStep(index: number) {
    this.step = index;
  }

  /**
   * increase one the step of app's flow
   */
  nextStep() {
    this.step++;
    if (this.step === 2) {
      setTimeout(() => {
        this.trigger.openPanel();
      }, 300);
    }
  }

  /**
   * Decrease one the step of app's flow
   */
  prevStep() {
    this.step--;
  }

  /**
   * At first, display first postion of variable according to Topic and subtopic filters
   * Then if user select a variable; Display the variable selected
   * @param variable Means the variable to display
   */
  displayFn(variable?: Question): string | undefined {
    return variable ? variable.shortName : undefined;
  }

  /** Sets null the value of Variable's autocomplete  */
  eraseSearch() {
    this.searchVariable.setValue(undefined);
  }

  /**
   * Reads which option of filters want to add to ENADIS
   * Are 2 options "Groups and Ambitos"
   * on selected show differents filters for group and for
   * ambito
   * @param evt Contains value of kind selected
   */
  changeView(evt) {
    this.selectedTopic = null;
    this.selectedSubtopic = null;
    this.queryParams = {};
    if (evt.target.checked) {
      this.showGroups.state = false;
      this.showGroups.mainText = ' ÁMBITO';
      this.showGroups.subText = ' CUESTIONARIO';
      this.searchVariable.setValue(undefined);
      this.filteredVariables = this.searchVariable.valueChanges
        .pipe(
          startWith(''),
          map(variable => variable ? this.filterVariables(variable) : this.variables.slice().sort(this.sortVariables))
        );
    } else {
      this.showGroups.state = true;
      this.showGroups.mainText = ' POBLACIÓN O GRUPO';
      this.showGroups.subText = ' TEMA';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/enadis/enadis-explore/enadis-explore.component.ts